module.exports = __webpack_public_path__ + "static/media/personalCard.e88de4f4.svg";